// import {
//   message
// } from 'ant-design-vue';
// import defaultSettings from '../defaultSettings';
// import {
//   Icon
// } from 'ant-design-vue';
import context from '@/main.js'

let lessNodesAppended

const colorList = [
  {
    key: 'blue',
    color: '#1890ff',
    primary1: 'purple',
    primary2: 'green',
    primary3: 'orange',
    primary4: 'green'
  },
  {
    key: 'geek',
    color: '#2f54eb',
    primary1: 'pink',
    primary2: 'cyan',
    primary3: 'orange',
    primary4: 'green'
  },
  {
    key: 'purple',
    color: '#722ed1',
    primary1: 'pink',
    primary2: 'cyan',
    primary3: 'orange',
    primary4: 'green'
  },
  {
    key: 'green',
    color: '#52c41a',
    primary1: 'purple',
    primary2: 'blue',
    primary3: 'orange',
    primary4: 'geek'
  },
  {
    key: 'pink',
    color: '#eb2f96',
    primary1: 'purple',
    primary2: 'cyan',
    primary3: 'orange',
    primary4: 'green'
  },
  {
    key: 'cyan',
    color: '#13c2c2',
    primary1: 'pink',
    primary2: 'green',
    primary3: 'orange',
    primary4: 'green'
  },
  {
    key: 'orange',
    color: '#fa8c16',
    primary1: 'pink',
    primary2: 'blue',
    primary3: 'green',
    primary4: 'purple'
  },
  {
    key: 'brown',
    color: '#cc6600',
    primary1: 'red',
    primary2: 'cyan',
    primary3: 'green',
    primary4: 'purple'
  },
  {
    key: 'red',
    color: '#f5222d',
    primary1: 'purple',
    primary2: 'cyan',
    primary3: 'orange',
    primary4: 'green'
  }
]

const updateTheme = primaryColor => {
  // Don't compile less in production!
  /* if (process.env.NODE_ENV === 'production') {
    return;
  } */
  // Determine if the component is remounted
  if (!primaryColor) {
    return
  }

  const hideMessage = context.$message.loading(context.$i18n.t('disp.setting.compile'), 0)

  function buildIt() {
    // 正确的判定less是否已经加载less.modifyVars可用
    if (!window.less || !window.less.modifyVars) {
      return
    }

    antd.Icon.setTwoToneColor(primaryColor)

    var primary = XEUtils.first(XEUtils.filter(colorList, r => r.color == primaryColor))
    var primary1 = XEUtils.first(XEUtils.filter(colorList, r => r.key == primary.primary1))
    var primary2 = XEUtils.first(XEUtils.filter(colorList, r => r.key == primary.primary2))
    var primary3 = XEUtils.first(XEUtils.filter(colorList, r => r.key == primary.primary3))
    var primary4 = XEUtils.first(XEUtils.filter(colorList, r => r.key == primary.primary4))

    // less.modifyVars可用
    window.less
      .modifyVars({
        '@primary-color': primary.color,
        '@primary1-color': primary1.color,
        '@primary2-color': primary2.color,
        '@primary3-color': primary3.color,
        '@primary4-color': primary4.color
      })
      .then(() => {
        context.$primaryColors = {
          primaryColorKey: primary.key,
          primaryColorValue: primary.color,
          primary1ColorKey: primary1.key,
          primary1ColorValue: primary1.color,
          primary2ColorKey: primary2.key,
          primary2ColorValue: primary2.color,
          primary3ColorKey: primary3.key,
          primary3ColorValue: primary3.color,
          primary4ColorKey: primary4.key,
          primary4ColorValue: primary4.color
        }

        hideMessage()
      })
      .catch(() => {
        context.$message.error('Failed to update theme')
        // hideMessage();
      })
  }

  setTimeout(() => {
    if (!lessNodesAppended) {
      // insert less.js and ui-color.less
      const lessStyleNode = document.createElement('link')
      const lessConfigNode = document.createElement('script')
      const lessScriptNode = document.createElement('script')
      lessStyleNode.setAttribute('rel', 'stylesheet/less')
      lessStyleNode.setAttribute('href', '/ui-color.less')
      lessConfigNode.innerHTML = `
        window.less = {
          async: true,
          env: 'production',
          javascriptEnabled: true
        };
      `
      lessScriptNode.src = '/less.min.js'
      lessScriptNode.async = true
      lessScriptNode.onload = () => {
        buildIt()
        lessScriptNode.onload = null
      }
      document.body.appendChild(lessStyleNode)
      document.body.appendChild(lessConfigNode)
      document.body.appendChild(lessScriptNode)
      lessNodesAppended = true
    } else {
      buildIt()
    }
  }, 500)
}

const updateColorWeak = colorWeak => {
  // document.body.className = colorWeak ? 'colorWeak' : '';
  colorWeak ? document.body.classList.add('colorWeak') : document.body.classList.remove('colorWeak')
}

export { updateTheme, colorList, updateColorWeak }

